import * as matches from "./matches";

export const isName = text => {
  return matches.nameMatch.test(text);
};

export const isEmail = text => {
  return matches.emailMatch.test(text);
};

export const isPhone = text => {
  return matches.phoneMatch.test(text);
};
